import Vue from 'vue';
export const EventBus = new Vue();
// formationIpfFormChanged
// formationPfFormChanged
//alterationUtochClose
//alterationUtochOpen
